import request, { RequestDocument } from 'graphql-request';
import { AnyStateConfig, setup } from 'xstate';
import { AnyEventObject, fromPromise, Mapper } from 'xstate';

import { FlowEntity, InitMachineParams } from '../../types';
import { getEvaluatedRoute } from '../helpers';

import {
    sendForgotPasswordLinkCacheKey,
    sendForgotPasswordLinkMutation,
} from './graphql/constants';

export type ForgotPasswordFlowContext = {
    email?: string;
    url?: string;
};

export const forgotPasswordActor: FlowEntity = {
    initActor: ({ queryClient }) =>
        fromPromise(async ({ input }) => {
            await queryClient.fetchQuery({
                queryKey: [sendForgotPasswordLinkCacheKey],
                queryFn: () => {
                    const requestHeaders = {
                        'request-source': sendForgotPasswordLinkCacheKey,
                    };

                    return request(
                        `/api/tn/app-shell/graphql/`,
                        sendForgotPasswordLinkMutation as RequestDocument,
                        { email: input.email },
                        {
                            ...requestHeaders,
                        },
                    );
                },
            });
        }),

    inputActor: <
        Mapper<ForgotPasswordFlowContext, AnyEventObject, ForgotPasswordFlowContext, AnyEventObject>
    >(({ context }) => {
        return { email: context.email };
    }),
};

export const ForgotPasswordFlow: FlowEntity = {
    initActor: (rawParams) => {
        const { config, actors, router } = rawParams as InitMachineParams;
        const machine = setup({
            types: {
                context: {} as ForgotPasswordFlowContext,
                input: {} as { url: string },
            },
            guards: {},
            actions: {
                goToForgotPasswordRoute: ({ context }) => {
                    if (context?.url) {
                        const evaluatedUrl = getEvaluatedRoute(router.pathname, context.url);
                        if (evaluatedUrl) {
                            router.push(evaluatedUrl);
                        }
                    }
                },
            },
            actors,
        }).createMachine({
            ...(config as AnyStateConfig),
            context: ({ input }) => ({
                ...input,
            }),
        });

        return machine;
    },
};
